import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

export function SortableItem({ id, children, className, style, handle = false, contentClassName = '' }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const itemStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 9999 : 'auto',
    opacity: isDragging ? 0.8 : 1,
    ...style
  };

  if (handle) {
    return (
      <div 
        ref={setNodeRef} 
        style={{
            ...itemStyle,
            display: 'flex',
            alignItems: 'stretch',
            borderRadius: '16px',
            overflow: 'hidden'
        }} 
        className={className}
      >
        <div 
            {...attributes} 
            {...listeners} 
            style={{ 
                cursor: 'grab', 
                width: '32px', // Token 32
                display: 'flex', 
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
                borderRight: '1px solid rgba(0,0,0,0.05)',
                color: '#98a2b3',
                transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
        >
            <DragIndicatorIcon sx={{ fontSize: 24 }} /> {/* Token 24 */}
        </div>
        <div className={contentClassName} style={{ flex: 1, minWidth: 0 }}>
            {children}
        </div>
      </div>
    );
  }

  return (
    <div ref={setNodeRef} style={itemStyle} className={className} {...attributes} {...listeners}>
      {children}
    </div>
  );
}
